import { ApplicationConfig, provideZoneChangeDetection } from '@angular/core';
import {
  provideRouter,
  withComponentInputBinding,
  withInMemoryScrolling,
} from '@angular/router';
import { provideAnimations } from '@angular/platform-browser/animations';
import {
  provideHttpClient,
  withInterceptors
} from '@angular/common/http';
import { provideNgxMask } from 'ngx-mask';

import { routes } from './routes/app.routes';
import { authInterceptor } from './core/interceptors/auth.interceptor';
import { languageInterceptor } from './core/interceptors/language.interceptor';
import { storeConfig, effectsConfig } from './core/store/store.config';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(
      routes,
      withInMemoryScrolling({
        scrollPositionRestoration: 'top',
      }),
      withComponentInputBinding()
    ),
    provideAnimations(),

    provideHttpClient(
      withInterceptors([
        authInterceptor,
        languageInterceptor
      ])
    ),
    storeConfig,
    effectsConfig,
    provideNgxMask(),
  ],
};
